import api from '../../api/index';

export default {
  namespaced: true,
  state     : {
    content: {
      list: [
        {
          title  : 'BMW',
          content: [
            {
              type   : 'listCards',
              content: [
                {
                  database_id: 1,
                  title      : 'BMW LL-01',
                },
                {
                  database_id: 13,
                  title      : 'BMW LL-04',
                },
                {
                  database_id: 3,
                  title      : 'BMW LL-03',
                },
                {
                  database_id: 8,
                  title      : 'BMW LL-11',
                },
              ],
            },
          ],
        },
        {
          title  : 'VW',
          content: [
            {
              type   : 'listTabs',
              content: [
                {
                  title  : 'VW 502 00/505 00',
                  content: {
                    text: {
                      title: 'Lorem ipsum dolor sit amet',
                      text : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                    },
                    links: [
                      {
                        database_id: 1,
                        title      : 'BMW LL-01',
                      },
                      {
                        database_id: 4,
                        title      : 'BMW LL-04',
                      },
                      {
                        database_id: 12,
                        title      : 'BMW LL-12',
                      },
                      {
                        database_id: 14,
                        title      : 'BMW LL-14 FE+',
                      },
                    ],
                  },
                },
                {
                  title  : 'SG',
                  content: {
                    text: {
                      text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
                    },
                    links: [
                      {
                        database_id: 1,
                        title      : 'BMW LL-01',
                      },
                      {
                        database_id: 4,
                        title      : 'BMW LL-04',
                      },
                      {
                        database_id: 5,
                        title      : 'BMW LL-04',
                      },
                      {
                        database_id: 14,
                        title      : 'BMW LL-04',
                      },
                    ],
                  },
                },
              ],
            },
          ],
        },
        {
          title  : 'Porsche',
          content: [
            {
              type   : 'listText',
              content: {
                title: '',
                text : '1232312',
              },
            },
          ],
        },
      ],
    },
  },
  getters: {
    list: ({content}) => content.list,
  },
  mutations: {
    SET_OEM(state, value) {
      state.content.list = value;
    },
  },
  actions: {
    async get_oem({commit}) {
      try {
        const get_oem = await api.database.get_oem();
        commit('SET_OEM', get_oem.data);
      } catch (err) {
        console.error(err);
      }
    },
  },
};
